import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const toolsService = {
  _url: process.env.REACT_APP_TOOLS_API_URL,

  GetToolsList(searchQuery, fetch) {
    const [data, setsData] = useState({
      tools: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllTools(searchQuery))
        .then(res => {
          setsData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [searchQuery, fetch]);

    return {
      _loading: status === STATUS.LOADING,
      _error: status === STATUS.ERROR,
      _data: data,
    };
  },

  async getAllTools(tool_type) {
    const query = tool_type ? `?tool_type=${tool_type}` : '';
    return await Fetch.get(`${this._url}/list${query}`);
  },

  async getToolDetails(id) {
    return await Fetch.get(`${this._url}/detail?tool_id=${id}`);
  },

  async updateTool(payload) {
    return await Fetch.put(`${this._url}/update`, payload);
  },

  async createTool(payload) {
    return await Fetch.post(`${this._url}/create`, payload);
  },

  async testTool(payload) {
    return await Fetch.post(`${this._url}/execute`, payload);
  },

  async deleteTool(id) {
    return await Fetch.delete(`${this._url}/delete?tool_id=${id}`);
  },
};

export default toolsService;
